import React from "react";
import { motion } from "framer-motion";
import { AmcLogo } from "./BookCover";
import { Heart, Sparkles } from "lucide-react";

export default function BackPage({ onGoContents }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="book-page ring-neon max-w-3xl mx-auto px-8 sm:px-12 py-14 sm:py-20 text-center"
      data-testid="back-page"
    >
      <div className="flex justify-center mb-8">
        <AmcLogo size={70} />
      </div>
      <div className="text-xs uppercase tracking-[0.4em] text-cyan-300/80 mb-4 font-heading">
        The End (for now)
      </div>
      <h2 className="font-display text-4xl sm:text-5xl font-extrabold text-white mb-6">
        Now go build <span className="neon-cyan">something.</span>
      </h2>
      <p className="font-body max-w-xl mx-auto text-slate-300 text-base sm:text-lg leading-relaxed mb-10">
        You&apos;ve read the whole book. You now know more than most people who claim to be experts online.
        The next chapter is written by <em>you</em> — with the app you build this weekend.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-3 mb-14">
        <button
          onClick={onGoContents}
          data-testid="back-to-contents-btn"
          className="px-6 py-3 rounded-full bg-slate-800/60 border border-cyan-400/40 text-cyan-200 hover:bg-slate-800 font-heading text-sm uppercase tracking-widest"
        >
          Back to Contents
        </button>
      </div>
      <div className="pt-10 border-t border-cyan-400/15 text-slate-500 text-xs font-heading uppercase tracking-widest flex items-center justify-center gap-2">
        <span>Made with</span>
        <Heart size={14} className="text-magenta-400" style={{ color: "#FF3C7E" }} />
        <span>by AMC inNOVAtions</span>
        <Sparkles size={14} className="text-cyan-300" />
      </div>
    </motion.div>
  );
}
